<template>
  <HandlerIos v-if="isIos" />
  <HandlerAndroid v-else-if="isAndroid" />
  <div v-else>
    <p>Browser tidak dikenal</p>
  </div>
</template>

<script>
import HandlerIos from '@/components/home/checkupPromo/HandlerIos.vue'
import HandlerAndroid from '@/components/home/checkupPromo/HandlerAndroid.vue'

export default {
  components: {
    HandlerIos,
    HandlerAndroid
  },
  setup () {
    const isIos = navigator.userAgent.includes('iPhone') || navigator.userAgent.includes('iPad')
    const isAndroid = navigator.userAgent.includes('Android')

    return {
      isIos,
      isAndroid
    }
  }
}
</script>
